import React from "react";
import { Hero, Section } from "../components/Page/Page.js";
import LeadForm from "../components/Page/LeadForm.js";

export default function ContactScreen() {
  return (
    <>
      <Hero title="Contact Us" text="Tell us about your project or offsetting needs and we'll get back to you." />
      <Section>
        <LeadForm
          kind="contact"
          button="Send message"
          fields={[["name", "Name"], ["email", "Email", "email"], ["message", "Message", "textarea"]]}
        />
      </Section>
    </>
  );
}
